import React from 'react'
import styled from 'styled-components'
import { transparentize } from 'polished'

const StyledInput = styled.input`
  display: block;
  box-sizing: border-box;
  width: 100%;
  background-color: ${props => props.theme.colors.gray200};
  border: none;
  border-radius: 0.25rem;
  height: 2.5rem;
  font-size: 1rem;
  padding: 0 0.5rem;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2pt
      ${props => transparentize(0.5, props.theme.colors.interactive)};
    background-color: ${props => props.theme.colors.gray50};
  }

  &[type='search'] {
    -webkit-appearance: none;
    -moz-appearance:    none;
    appearance:         none;
  }
`

export default ({ label, ...rest }) => (
  <div>
    {label && (
      <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>
    )}
    <StyledInput {...rest} />
  </div>
)
